import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'
import routes from './filterRoutesByRole'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']

  if (from.fullPath !== '/login') {
    if (to.fullPath !== '/login' && !isAuthenticated) {
      router.push('/login')
    }
  }
})

export default router
